var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedVegV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3576 10.6419L12.8341 11.226L11.3385 10.3499C11.189 10.2768 10.9647 10.2768 10.8151 10.4959C10.6655 10.7149 10.7403 10.861 10.9647 11.007L12.3107 11.8102L9.76821 14.5848L8.42221 13.7816C8.27265 13.7086 8.04832 13.7086 7.89877 13.9276C7.82399 14.0736 7.82399 14.2927 8.04832 14.4387L9.24477 15.1689L8.27265 16.2641C7.82399 16.9943 6.92665 17.2133 6.25365 16.7752C5.50587 16.3371 5.28154 15.4609 5.73021 14.8038L6.92665 11.226L7.89877 11.8102C8.04832 11.8832 8.27265 11.8832 8.42221 11.6641C8.49699 11.5181 8.49699 11.2991 8.27265 11.153L7.15099 10.4959L8.1231 7.64828C8.64654 6.99114 9.61866 6.62606 10.6655 6.84511L10.516 5.09273C10.516 4.65464 10.8151 4.36258 11.189 4.28956C11.5629 4.21655 11.9368 4.58162 12.0115 4.9467L12.0863 5.53083L12.7593 4.36258C12.9837 3.9975 13.4323 3.92448 13.8062 4.07051C14.1801 4.28956 14.2549 4.72765 14.1053 5.09273L13.2828 6.55304L14.9279 5.96892C15.3018 5.82289 15.7504 6.04193 15.9 6.40701C15.9 6.84511 15.6757 7.21018 15.3018 7.35621L12.9837 8.15939C13.5819 8.96256 13.8062 9.91176 13.3576 10.6419Z",
    fill: "#79A303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedVegV2);
export default __webpack_public_path__ + "static/media/rounded-veg-v2.9f6b301dd1c23c9c3dce1da707002469.svg";
export { ForwardRef as ReactComponent };